module.exports = __webpack_public_path__ + "img/teacherReading.6a18b279.jpg";